import type { TransactionsViewQuery } from '@bts-web/data-layer/server';
import { flex } from '@bts-web/utils-style-engine';
import { TransactionItem } from '../TransactionItem/TransactionItem';
import { TransactionEntryType } from '../utils/transactionTypesUtils';
import { TransactionItemTranslationsKeys } from '../types/transactions';

export interface TransactionListProps {
  transactions: NonNullable<
    NonNullable<TransactionsViewQuery['response']['transactions']>['edges']
  >;
  translations: TransactionItemTranslationsKeys;
  locale: string;
}

export const TransactionList = ({
  transactions,
  translations,
  locale,
}: TransactionListProps) => {
  return (
    <ul
      className={flex({ flexDirection: 'column' })}
      data-testid="transaction-list"
    >
      {transactions.map((transaction) => {
        return (
          <TransactionItem
            key={transaction?.node?.id}
            transaction={transaction!.node as TransactionEntryType}
            showCategoryTypeChip
            translations={translations}
            locale={locale}
          />
        );
      })}
    </ul>
  );
};
